import { DATA_REQUEST_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: {
      mailboxes: [],
    },
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
